module.exports = __webpack_public_path__ + "static/media/pharmacy-prescription-billing-software.9c61b6e5.webp";